import React from 'react'
import PreloadImage from './PreloadImage'
import './Image.css'

class CustomImage extends React.Component {
  constructor(props) {
    super(props)

    this.image = new Image()
    this.image.onload = () => this.setState({ aspectRatio: this.image.height / this.image.width * 100 })
    this.image.src = this.props.src

    this.state = {
      aspectRatio: this.props.aspectRatio
    }
  }

  componentWillUnmount() {
    this.image.onload = null
  }

  render() {
    const classNames = ['Image']

    if(this.props.full) classNames.push('is-fullwidth')

    return (
      <div className={classNames.join(' ')} style={this.props.style}>
        <div style={{ paddingBottom: `${this.state.aspectRatio}%` }}>
          <PreloadImage image={this.props.src}>
            {image => (
              <img src={image} alt={this.props.title} />
            )}
          </PreloadImage>
        </div>
      </div>
    )
  }
}

CustomImage.defaultProps = {
  aspectRatio: 30,
}

export default CustomImage



// WEBPACK FOOTER //
// ./src/components/library/image/Image.js